import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { TransmissionStation } from '../models/transmission.station.model';

@Injectable({
  providedIn: 'root'
})
export class TsService {

  private pathApi = this.config.setting['pathApi'] + "transmissionStation/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  save(ts: TransmissionStation): Observable<any> {
    return this.http.post(`${this.pathApi}save`, ts);
  }

  delete(id: number, record: string = ''): Observable<any> {
    const query = record ? `?record=${encodeURIComponent(record)}` : '';
    return this.http.delete(`${this.pathApi}delete/${id}${query}`);
  }

  getAllForSelect(utilityId: number | null = null): Observable<any> {
    if(utilityId) {
      return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, {observe: 'response'});
    }
    else {
      return this.http.get(`${this.pathApi}getAllForSelect`, {observe: 'response'});
    }
  }

  downloadFile(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, dataIn);
  }
}
